import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

// Guards
import { PlayGuard } from './guards/play/play.guard';

// Services
import { ApiService } from './http/api.service';
import { AppFunctionalitiesService } from './http/appFunctionalities/appFunctionalities.service';
import { ConfigService } from './http/config/config.service';
import { ActivationCodeService } from './http/activation-code/activation-code.service';
import { TrialService } from './http/trial/trial.service';
import { ToReproduceService } from './http/toReproduce/toReproduce.service';

const GUARDS = [PlayGuard];

const HTTP_SERVICES = [
  AppFunctionalitiesService,
  ConfigService,
  ActivationCodeService,
  ToReproduceService,
  TrialService,
];

@NgModule({
  declarations: [],
  imports: [CommonModule, IonicModule],
  exports: [],
  providers: [...GUARDS, ApiService, ...HTTP_SERVICES],
})
export class CoreModule {}
